module.exports = __webpack_public_path__ + "media/images/translation_center_logo-9f174385dbf928264a6208319936fb20.png";